export default "__VITE_ASSET__Wq5RVp3Z__"